/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { NavigationSection } from '@squiz/sds';
import {
  DXP_MENU_ADVANCED_FORMS_SCREENS,
  DXP_MENU_CONTENT_MANAGEMENT_SCREENS,
  DXP_MENU_DATA_SERVICES_SCREENS,
  DXP_MENU_INTEGRATIONS_SCREENS,
  DXP_MENU_SEARCH_SCREENS,
} from './NavItems.constants';
import { INSTANCE_MANAGEMENT_STRINGS } from './Strings.constants';

/**
 * The main navigation menu section for general Advanced Forms screens.
 */
export const DXP_MENU_ADVANCED_FORMS_SECTION: NavigationSection = {
  items: DXP_MENU_ADVANCED_FORMS_SCREENS,
  key: `menu-section-advanced-forms`,
  label: INSTANCE_MANAGEMENT_STRINGS.advancedForms,
  showLabel: false,
};

/**
 * The main navigation menu section for general Content Management screens.
 */
export const DXP_MENU_CONTENT_MANAGEMENT_SECTION: NavigationSection = {
  items: DXP_MENU_CONTENT_MANAGEMENT_SCREENS,
  key: `menu-section-content-management`,
  label: INSTANCE_MANAGEMENT_STRINGS.contentManagement,
  showLabel: false,
};

/**
 * The navigation menu section for the data services capability.
 */
export const DXP_MENU_DATA_SERVICES_SECTION: NavigationSection = {
  items: DXP_MENU_DATA_SERVICES_SCREENS,
  key: `menu-section-data-services`,
  label: INSTANCE_MANAGEMENT_STRINGS.dataServices,
  showLabel: false,
};

/**
 * The main navigation menu section for general Integrations screens.
 */
export const DXP_MENU_INTEGRATIONS_SECTION: NavigationSection = {
  items: DXP_MENU_INTEGRATIONS_SCREENS,
  key: `menu-section-integrations`,
  label: INSTANCE_MANAGEMENT_STRINGS.integrations,
  showLabel: false,
};

/**
 * The main navigation menu section for general Search screens.
 */
export const DXP_MENU_SEARCH_SECTION: NavigationSection = {
  items: DXP_MENU_SEARCH_SCREENS,
  key: `menu-section-search`,
  label: INSTANCE_MANAGEMENT_STRINGS.search,
  showLabel: false,
};
